
/**
 * Represents the various state a task can be in
 */
 export enum Statuses {
    Unknown,
    Todo,
    Pending,
    Completed,
    Missing,
    Upgradable,
    Failed,
    PreviouslyCompleted,
    Paused
}


export enum InputTypes {
    Text,
    Checkbox,
    User,
    Profiles
}


export interface TaskInput {
    name: string;
    type: InputTypes;
    default?: any;
    taskParameters?: TaskParameters;
    defaultChecked?: boolean;
    isSelected?: boolean;
}

export interface TaskParameters {
    packageId?: string | '';
    subscriberId?: string | '';
    taskName?: string | '';
    isOptional?: string | '';
    externalPackage?: string | '';
    externalPackageOld?: string | '';
    testClass?: string | '';
    dependentExtension?: any | '';
    dependentExtensionVersion?: string | '';
    migrationBatches?: any[] | [];
    objectNames?: string[] | '';
    run_setupData?: string | '';
    query?: string | '';
    nestedForModule?: string | '';
    objectTranslation?: any[] | [];
    prefix?: string | '';
    from?: string | '';
    to?: string | '';
    defaultChecked?: boolean | undefined;
    pushUpgrade?: boolean | undefined;
}


/**
 * Represents the status of a task
 */
 export class ITaskStatus {
    status : Statuses = Statuses.Unknown;
    message ?: string;
    lastAttemptedOn ?: Date;
    progress ?: number;
}

/**
 * Represents the callback that is called when changes are to be notified.
 */
export interface ITaskCallback {
    notifyUpdate(status: ITaskStatus, subtaskid?: string, task?: ITask) : void;
    // waitForStatus(status: Statuses) : Promise<ITaskStatus>;
}


/**
 * Represents the basic instance of task, which can be run to achieve an objective
 */
export interface ITask {
    taskStatus: Promise<Statuses>;
    name: string;
    description ?: string;
    /**
     * The method is invoked to start the task by the task engine
     * @param rerun indicates whether the task should be re-run even if it was completed previously
     * @param progressCallback the callback method that should be notified when task progresses asynchronously
     * @param variables the map of variables that contains the various options such as profiles to configure, test to run etc.
     */
    run(rerun: boolean, progressCallback: ITaskCallback, variables : any): Promise<ITaskStatus>;
    taskInputs: TaskInput[];
    progress ?: number;
    errorMsg ?: string;
    overwritableByNextVersion ?: boolean;
    isOptional: boolean;
    isParallel ?: boolean;
    wasPreviouslyCompleted ?: boolean;
    dependentExtension ?: string | boolean;
    label ?: string;
    
    /**
     * Represents whether this task requires manual intervention
     */
     isManual: boolean;
     
    /**
     * Returns the list of sub tasks for the give step 
     */
    subTasks: ITask[];

     /**
     * The module for which this task is defined.
     */
    forModule ?: string;
    /*
    * Return string concat of task name and moduleIdentifier
    */
    uniqueName ?: string;
    /**
     * The module for which this task is defined eg : moduleIdentifier":"14.0.x to 14.5.0"
     */
    moduleIdentifier ?: string;
    /**
     * Checks whether or not a particular task has been already executed
     * @param conn SF connection to use to get data and config from SF
     */
    initialize(): Promise<void>;

    defaultChecked ?: boolean;
}

export interface IComponentFailure {
    [key: string]: string
}